import type { CatalogKey } from "./catalogs";
import type { CatalogIndexPayload, CatalogPayload } from "./types";
import type {
  PromotionSiteIndexPayload,
  PromotionSitePagePayload,
} from "./types";

export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

async function readJson<T>(response: Response): Promise<T> {
  const payload = await response.json().catch(() => ({})) as { message?: string };
  if (!response.ok) {
    throw new ApiError(payload.message || "No pudimos cargar esta selección.", response.status);
  }
  return payload as T;
}

export async function loadCatalogIndex(): Promise<CatalogIndexPayload> {
  return readJson<CatalogIndexPayload>(await fetch("/api/v1/catalogs", {
    headers: { Accept: "application/json" },
    cache: "no-store",
  }));
}

export async function loadCatalog(catalog: CatalogKey): Promise<CatalogPayload> {
  return readJson<CatalogPayload>(await fetch(
    `/api/v1/catalogs/${encodeURIComponent(catalog)}`,
    { headers: { Accept: "application/json" } },
  ));
}

export async function loadPromotionSiteIndex(): Promise<PromotionSiteIndexPayload> {
  return readJson<PromotionSiteIndexPayload>(await fetch("/api/v1/promotion-site", {
    headers: { Accept: "application/json" },
    cache: "no-store",
  }));
}

export async function loadPromotionSitePage(slug: string): Promise<PromotionSitePagePayload> {
  return readJson<PromotionSitePagePayload>(await fetch(
    `/api/v1/promotion-site/${encodeURIComponent(slug)}`,
    { headers: { Accept: "application/json" }, cache: "no-store" },
  ));
}

export async function submitPromotionSiteSampleRequest(input: {
  handle: string;
  pageSlug: string;
  pid: string;
  releaseId: string;
}): Promise<{ accepted: true }> {
  return readJson<{ accepted: true }>(await fetch("/api/v1/sample-requests", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(input),
  }));
}

export const submitFullManagedSampleRequest = submitPromotionSiteSampleRequest;
